import mutations from './mutations';

const BaseData = {
    namespaced: true,
    state: {
        app_name: 'Pendaftaran Online',
        company_name: 'RSUD GENENG',
        moto : '',
        visi : [
            ''
        ],
        misi : [
            ''
            
        ],
        address: 'Jl. Maospati – Solo No.34, Tambakromo, Geneng, Ngawi, Jawa Timur 63271',
        description: 'Dalam mewujudkan Visi Misi Bupati dan Wakil Bupati Kabupaten Ngawi dalam Bidang Kesehatan, maka pembangunan kesehatan di Kabupaten Ngawi dilakukan secara komprehensif, dengan tujuan untuk meningkatkan derajat kesehatan masyarakat secara nasional dan daerah (khususnya derajat kesehatan di Kabupaten Ngawi). Berbagai upaya dilakukan oleh Pemerintah Kabupaten Ngawi dalam upaya memberikan layanan kesehatan terbaik untuk masyarakat, diantaranya adalah penguatan layanan puskesmas, layanan jaminan kesehatan masyarakat Ngawi, serta pembangunan 2 (dua) RSUD baru yaitu RSUD Geneng dan RSUD Mantingan agar akses kesehatan masyarakat semakin dekat. Penguatan layanan kesehatan masyarakat diberikan dalam layanan reguler/umum, rujukan dan jaminan.',
        email: 'rsudgeneng@ngawikab.go.id',
        phone: '(0351) 7403000',
        fax: '--',

        sosmed : [
            {
                'icon'  : ['fab', 'chrome'],
                'title' : 'Website',
                'url'   : 'https://rsudgeneng.ngawikab.go.id/',
                'keterangan' : '',
                'bg_color' : 'bg-yellow-100',
                'icon_color' : 'text-green-800',
                'text_color' : 'text-green-800',
            },
            {
                'icon'  : ['fab', 'instagram'],
                'title' : 'Instagram',
                'url'   : 'https://www.instagram.com/rsudgeneng/',
                'keterangan' : '',
                'bg_color' : 'bg-purple-200',
                'icon_color' : 'text-pink-600',
                'text_color' : '',
            },
            {
                'icon'  : ['fab', 'facebook'],
                'title' : 'Facebook',
                'url'   : 'https://www.facebook.com/rsudgeneng',
                'keterangan' : '',
                'bg_color' : 'bg-indigo-200',
                'icon_color' : 'text-green-800',
                'text_color' : '',
            },
            {
                'icon'  : ['fab', 'youtube'],
                'title' : 'Youtube',
                'url'   : 'https://www.youtube.com/@rsudgeneng',
                'keterangan' : '',
                'bg_color' : 'bg-green-200',
                'icon_color' : 'text-red-700',
                'text_color' : '',
            },
            
        ],
        main_icon: '',
        second_icon: 'https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/cropped-Logo-Landscape-RSUD-Geneng-Motto-Blenda-300x122.png',
        img_background: '',
        main_theme_color: '#05940C',
        second_theme_color: '#424237',
        version: '1.0.0',
    },
    mutations
};

export default BaseData;
